<template>
  <div class="menubar" :class="{ 'menubar--gradient': gradient }">
    <router-link to="/">
      <FeedbackCompanyLogo :height="32" />
    </router-link>
    <slot class="menubar-content"></slot>
  </div>
</template>

<script>
import FeedbackCompanyLogo from "../../atoms/FeedbackCompanyLogo.vue";

export default {
  name: "DesktopMenubar",
  components: {
    FeedbackCompanyLogo,
  },
  props: {
    gradient: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../style_variables/style_variables.scss";

.menubar {
  width: 100%;
  height: 56px;
  padding: 0px 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  z-index: 3;
  background: $white;
  border-bottom: 1px solid $grey_alabaster;

  &.menubar--gradient {
    height: 54px;
    border-image: linear-gradient(to left, $green, $blue);
    border-width: 5px;
    border-top: 0;
    border-left: 0;
    border-right: 0;
    border-image-slice: 1;
  }
}
.menubar-content {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
